export default __webpack_public_path__ + "static/media/customer-satisfaction.baa58f4d.svg";